import { render, staticRenderFns } from "./NominacionCreate.vue?vue&type=template&id=3906aeb1"
import script from "./NominacionCreate.vue?vue&type=script&lang=js"
export * from "./NominacionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports